import 'rxjs/add/operator/combineLatest';
import {getItemFromState} from '../../../_libs/redux-observable-list';
import {getAssetProjectReduxItem, getProjectReduxItem} from '../../../app/model/reducers/state';
import {buildBreadcrumbPath$, getProjectIdFromPath} from '../../../app/navigation/utils';
import {TaskType} from '../../../tasks/enums/TaskType';
import {ASSET_PROJECT_COLLECTION, PROJECT_COLLECTION} from '../../domain/config';


export const Container = (config) => (state$, dispatch) => (props$) => {
  const {
    taskType,
  } = config;

  const breadcrumbPath$ = buildBreadcrumbPath$({state$, taskType});

  const projectItem$ = state$
    .map(taskType === TaskType.ASSET ? getAssetProjectReduxItem : getProjectReduxItem)
    .distinctUntilChanged();

  return props$
    .combineLatest(
      breadcrumbPath$,
      projectItem$,
      (props, breadcrumbPath, projectItem) => ({
        ...props,
        breadcrumbPath,
        project: getItemFromState(projectItem),
        parentId: getProjectIdFromPath(breadcrumbPath, taskType),
        collection: taskType === TaskType.ASSET ? ASSET_PROJECT_COLLECTION : PROJECT_COLLECTION,
        // init: !!getProjectIdFromPath(breadcrumbPath, taskType),
      }));
};



// WEBPACK FOOTER //
// ./src/js/projects/components/ProjectViewTimerLog/Container.js